import { uniqBy } from 'lodash';

import {
  DeviceOfferDetail,
  DeviceOfferDetails,
  InputOption,
} from 'journey/productDetails/typings';
import { convertToKiloBytes } from 'shared/utils/convertToKiloBytes.utils';

const storageOptionsComparer = (a: InputOption, b: InputOption) => {
  return convertToKiloBytes(a.label) - convertToKiloBytes(b.label);
};

export const generateStorageOptions = (offers: DeviceOfferDetails) => {
  return uniqBy(offers, 'storage')
    .filter((offer) => offer?.storage)
    .map(({ storage }) => ({
      label: storage.toUpperCase(),
      value: storage,
    }))
    .sort(storageOptionsComparer);
};

export const getStorageOptionsByColor = (
  offers: DeviceOfferDetails,
  selectedColor: string,
  selectedStorage: string,
) => {
  let availableOffers = offers;

  if (selectedColor) {
    availableOffers = offers.filter(
      (offer) => offer.colorHex === selectedColor,
    );
  }

  const newStorageOptions = generateStorageOptions(availableOffers);

  const newSelectedStorage = newStorageOptions.find(
    (option) => option.value === selectedStorage,
  )
    ? selectedStorage
    : newStorageOptions?.[0]?.value;

  return {
    newSelectedStorage,
    newStorageOptions,
  };
};

export const getStorageOptionsFromSelectedDevice = ({
  deviceOffers,
  selectedDevice,
}: {
  deviceOffers: DeviceOfferDetails;
  selectedDevice: DeviceOfferDetail;
}) => {
  const { newSelectedStorage, newStorageOptions } = getStorageOptionsByColor(
    deviceOffers,
    selectedDevice.colorHex,
    selectedDevice.storage,
  );
  return {
    selectedDeviceStorage: newSelectedStorage,
    selectedDeviceStorageOptions: newStorageOptions,
  };
};
